import {debug} from "util";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";


export class SectionDragManager{
    private dragDeltaX=0;
    private dragDeltaY=0;
    private originalX=0;
    private originalY=0;
    private dragging=false;
    private clicked=false;
    private $body:JQuery;
    private lastResizeDirection:ResizeDirection;
    private clickedResizeDirection:ResizeDirection;

    private resizeOriginalOffset;
    private resizeOriginalWidth;
    private resizeOriginalHeight;
    private resizeOriginalTop;
    private resizeOriginalLeft;
    private resizeContainerOffset;
    private resizeContainerWidth;
    private resizeContainerHeight;

    private ResizeUpdateTimeOut=null;


    public $element:JQuery;
    constructor(element:JQuery, public page:PDFDocument, public resizeLocation:ResizeLocation, public $contentContainer:JQuery)
    {

        this.$element=element;
        this.$body=jQuery('body');
        this.$element.mousedown((event)=>this.OnMouseDown(event));
        this.$element.mousemove((event)=>this.OnMouseMove(event));
        this.$element.mouseleave((event)=>this.OnMouseLeave(event));

        this.OnResizeMove=this.OnResizeMove.bind(this);
        this.OnResizeEnd=this.OnResizeEnd.bind(this);

    }

    private OnMouseDown(event: any) {
        let offset=this.$element.offset();
        this.dragDeltaX=event.pageX-offset.left;
        this.dragDeltaY=event.pageY-offset.top;
        this.originalX=event.pageX;
        this.originalY=event.pageY;
        if(this.lastResizeDirection!=null)
        {
            event.stopPropagation();
            this.originalX-=this.dragDeltaX;
            this.originalY-=this.dragDeltaY;
            this.resizeContainerOffset=this.$element.parent().offset();
            this.resizeContainerWidth=this.$element.parent().width();
            this.resizeContainerHeight=this.$element.parent().height();
            this.resizeOriginalOffset=this.$element.offset();
            this.resizeOriginalHeight=this.$element.outerHeight();
            this.resizeOriginalWidth=this.$element.outerWidth();
            this.resizeOriginalTop=parseInt(this.$element.css('top'),10);
            this.resizeOriginalLeft=parseInt(this.$element.css('left'),10);

            this.clickedResizeDirection=this.lastResizeDirection;
            this.clicked=true;
            jQuery(window)
                .on('mousemove',this.OnResizeMove)
                .on('mouseup',this.OnResizeEnd);
            return;

        }

    }


    private OnResizeMove(event:any){
        let offset=this.$element.offset();
        let newTop=-1;
        let newLeft=-1;
        let newWidth=-1;
        let newHeight=-1;
        let width=this.$element.outerWidth();
        let height=this.$element.outerHeight();

        if(this.clickedResizeDirection=='tr'||this.clickedResizeDirection=="tl"||this.clickedResizeDirection=="t")
        {
            let pageY=Math.max(event.pageY,this.resizeContainerOffset.top);
            let deltaY=Math.ceil(pageY-this.originalY);
            if(deltaY<0||this.resizeOriginalHeight-deltaY>30)
            {
                newTop=this.resizeOriginalTop+deltaY;
                newHeight=this.resizeOriginalHeight+deltaY*-1;
            }
        }

        if(this.clickedResizeDirection=='bl'||this.clickedResizeDirection=="b"||this.clickedResizeDirection=="br")
        {
            let pageY=Math.min(event.pageY,this.resizeContainerOffset.top+this.resizeContainerHeight);
            let deltaY=Math.ceil(pageY-this.originalY);
            deltaY-=this.resizeOriginalHeight;
            if(deltaY>0||this.resizeOriginalHeight+deltaY>30)
            {
                newHeight=this.resizeOriginalHeight+deltaY;
            }
        }


        if(newTop>=0) {
            //this.$element.css({top: newTop});
            //this.RunnableElement.Options.styles.top=newTop+'px';
        }
        if(newHeight>=0) {
            let oldHeight=this.$element.outerHeight();
            let containerHeight=this.$contentContainer.outerHeight();
            let deltaHeight=newHeight-oldHeight;
            let originalDelta=deltaHeight;

            if(deltaHeight+20>containerHeight)
                deltaHeight=containerHeight-20;
            console.log({oldContainerHeight:containerHeight, newContainerHeight:containerHeight-deltaHeight,oldHeight:this.$element.height(),newElementHeight:oldHeight+deltaHeight,delta:deltaHeight});

            this.$contentContainer.css({height:containerHeight-deltaHeight});
            this.$element.css({height: oldHeight+deltaHeight});

            //this.RunnableElement.Options.styles.height=newHeight+'px'
        }


    }

    private OnResizeEnd(event:any){
        this.clicked=false;
        jQuery(window)
            .off('mousemove',<any>this.OnResizeMove)
            .off('mouseup',this.OnResizeEnd);

        this.page.UpdateSectionSize();
    }



    private OnMouseMove(event: any) {
        let x = event.pageX;
        let y = event.pageY;
        if(!this.clicked)
        {

            let resizeDirection=this.GetResizeDirection(x,y);
            let cursor;
            if(resizeDirection==null)
                cursor='';

            if (resizeDirection=="t")
                cursor='n-resize';
            if (resizeDirection=="b")
                cursor='s-resize';
            this.$body.css('cursor',cursor);
            this.$element.css('cursor',cursor);
            this.lastResizeDirection=resizeDirection;
        }


    }


    private GetResizeDirection(x: number, y: number):ResizeDirection {
        let offset=this.$element.offset();

        let height=this.$element.outerHeight();
        const resizeGap=10;
        if(y<offset.top||y>offset.top+height)
            return null;

        if(y<offset.top+resizeGap&&this.resizeLocation=="top")
        {
            return "t";
        }


        if(y>offset.top+height-resizeGap&&this.resizeLocation=="bottom")
        {
            return "b";
        }


        return null;


    }

    private OnMouseLeave(event: any) {
        this.$body.css('cursor','');
        this.$element.css('cursor','')

    }

}

export type ResizeLocation='top'|'bottom';
type ResizeDirection="t"|"tl"|"l"|"bl"|"b"|"br"|"r"|"tr";